module.exports = __webpack_public_path__ + "static/img/12.fc5116e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/zh/12.png
// module id = xDxo
// module chunks = 0